/**
 * Build a small context object for the chat API from current page and app state.
 * Used so the AI has page/report/class context when answering.
 *
 * @param {{ pathname: string, params?: Record<string, string>, currentClass?: { classId: string | number, className?: string } | null, report?: { id?: string, globalFilters?: object } | null, schoolId?: string | number }} opts
 * @returns {object} context for POST /api/v1/chat
 */
export function buildChatPageContext(opts) {
    const { pathname = '', params = {}, currentClass, report, schoolId } = opts;
    const context = {
        pathname,
        page: derivePageFromPathname(pathname),
    };

    if (params?.classId != null) {
        context.classId = params.classId;
    }
    if (currentClass?.classId != null) {
        context.classId = String(currentClass.classId);
        if (currentClass.className) context.className = currentClass.className;
    }
    if (schoolId != null) {
        context.schoolId = schoolId;
    }
    if (report?.id) {
        context.reportId = report.id;
    }
    if (report?.globalFilters && typeof report.globalFilters === 'object') {
        const gf = report.globalFilters;
        context.globalFilters = {};
        if (gf.classIds?.length) context.globalFilters.classIds = gf.classIds;
        if (gf.gradeIds?.length) context.globalFilters.gradeIds = gf.gradeIds;
        if (gf.period) context.globalFilters.period = gf.period;
        if (gf.startDate) context.globalFilters.startDate = gf.startDate;
        if (gf.endDate) context.globalFilters.endDate = gf.endDate;
    }

    return context;
}

function derivePageFromPathname(pathname) {
    if (!pathname) return 'unknown';
    if (pathname.includes('weekly-report')) return 'weekly-report';
    if (pathname.includes('planning-report')) return 'planning-report';
    if (pathname.includes('class') && (pathname.includes('/class/') || pathname.includes('/classes'))) return 'class-dashboard';
    if (pathname.includes('lessons') || pathname.includes('curriculum')) return 'lessons';
    if (pathname.includes('survey') || pathname.includes('surveys')) return 'surveys';
    if (pathname.includes('school')) return 'school-dashboard';
    if (pathname.includes('report')) return 'reports';
    return 'other';
}
